<template lang="pug">
  nav.breadcrumb(aria-label="breadcrumbs")
    ul(v-if="$breadcrumbs.length")
      li
        router-link(:to="{ path: '/test' }") Accueil
      li(v-for="(crumb, key) in $breadcrumbs" :key="key")
        router-link(:to="crumb.path" v-if="++key != $breadcrumbs.length")
          | {{ crumb.meta.breadcrumb }}
        span.is-current(v-else)
          | {{ crumb.meta.breadcrumb }}
</template>

<script>
  import Vue from 'vue'
  import { Component } from 'vue-property-decorator'

  @Component()
  export default class Breadcrumb extends Vue {
  }
</script>
